module.exports = __webpack_public_path__ + "./docs/img/big-icon-getter.6acd740a6247e10a3d6b574a32ece99a.svg";